var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowTriangleDown = function SvgArrowTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.701 11.753 12 10.6a.61.61 0 0 0 .8 0l12-10.6a.6.6 0 0 0-.365-1.048.61.61 0 0 0-.435.148l-11.6 10.25-11.6-10.25a.61.61 0 0 0-.85.05.6.6 0 0 0 .05.85Z",
    fill: "currentColor"
  })));
};

export default SvgArrowTriangleDown;